module.exports = {"341203001":"河东","341203002":"新华街道","341203003":"向阳街道","341203100":"口孜镇","341203101":"插花镇","341203102":"袁寨镇","341203103":"枣庄镇","341203104":"老庙镇","341203105":"正午镇","341203106":"杨楼孜镇","341203107":"新乌江镇","341203200":"冉庙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341203.json
// module id = 1030
// module chunks = 0